var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFornoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.001,
    height: 24.375,
    viewBox: "0 0 30.001 24.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forno",
    d: "M-1138.312-5975.625v-.937h-9.375v.938h-5.625v-.937H-1154a4,4,0,0,1-4-4V-5996a4,4,0,0,1,4-4h22a4,4,0,0,1,4,4v15.438a4.005,4.005,0,0,1-4,4h-.688v.938Zm-18.75-6.562a3.754,3.754,0,0,0,3.75,3.75h20.625a3.754,3.754,0,0,0,3.75-3.75v-12.188h-28.125Zm1.875-8.437a.938.938,0,0,1-.938-.938.938.938,0,0,1,.938-.938h24.376a.938.938,0,0,1,.937.938.938.938,0,0,1-.937.938Z",
    transform: "translate(1158 6000)",
    fill: "#F8F4FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFornoDark);
export default __webpack_public_path__ + "static/media/FornoDark.6e5ee95858b9d6052790700c3571d115.svg";
export { ForwardRef as ReactComponent };